import React from 'react'
import Svg from '../../../components/Svg/Svg'
import { SvgProps } from '../../../components/Svg/types'

const Icon: React.FC<SvgProps> = (props) => {
  return (
    <Svg viewBox="0 0 120 138" {...props}>
      <defs>
        <clipPath id="clip-dcent-logomark-full-colored_d_cent_mint">
          <rect width="120" height="138" />
        </clipPath>
      </defs>
      <g
        id="dcent-logomark-full-colored_d_cent_mint"
        data-name="dcent-logomark-full-colored d'cent mint"
        clipPath="url(#clip-dcent-logomark-full-colored_d_cent_mint)"
      >
        <g id="그룹_44" data-name="그룹 44" transform="translate(1 2)">
          <path
            id="패스_196"
            data-name="패스 196"
            d="M463.186,437.127l10.07-5.8V417.514l-10.07-5.8h0Z"
            transform="translate(-402.361 -411.718)"
            fill="#a4a7a9"
          />
          <path
            id="패스_197"
            data-name="패스 197"
            d="M465.138,497.325V458.431l33.625-19.339V411.718l-55.707,32.059a3.4,3.4,0,0,0-1.707,2.939v64.093c0,.067.011.134.011.189Z"
            transform="translate(-441.348 -411.717)"
            fill="#6fc9c4"
          />
          <path
            id="패스_198"
            data-name="패스 198"
            d="M532.916,443.433,499.261,462.8,465.814,443.55l-23.792,13.69,55.537,31.948a3.47,3.47,0,0,0,1.707.454,3.538,3.538,0,0,0,1.7-.454l55.71-32.054.022-.02Z"
            transform="translate(-440.145 -355.096)"
            fill="#6d6e71"
          />
          <path
            id="패스_199"
            data-name="패스 199"
            d="M512.558,431.374l-22.091-12.709V432.48l-23.734,13.659,23.734,13.643v24.906l23.789,13.681V434.313A3.383,3.383,0,0,0,512.558,431.374Z"
            transform="translate(-396.026 -399.315)"
            fill="#a4a7a9"
          />
          <path
            id="패스_200"
            data-name="패스 200"
            d="M458.343,441.872v27.106l23.1-13.291v-27.1Z"
            transform="translate(-411.007 -381.607)"
            fill="#6d6e71"
          />
        </g>
      </g>
    </Svg>
  )
}

export default Icon
